export interface AnalysisParams {
  tp_usd: number;
  sl_usd: number;
  quantity_base: number;
  initial_capital: number;
  selected_qty_values: string[];
  loss_streak_enabled: boolean;
  max_consecutive_losses: number;
  resume_after_win: boolean;
  win_protect_enabled: boolean;
  win_protect_start_wins: number;
  win_protect_max_wins: number;
  win_protect_include_nth_win: boolean;
  win_protect_mode: 'consecutive_trades' | 'consecutive_losses';
  // Anti Loss Streak fields
  anti_loss_streak_enabled: boolean;
  wait_for_losses: number;
  stop_after_losses: number;
  reset_on_win: boolean;
  anti_loss_streak_mode: 'consecutive_losses' | 'consecutive_trades';
  // New percentage-based calculation fields
  use_percentage_mode: boolean;
  tp_percent: number;
  sl_percent: number;
  auto_parse_filename: boolean;
  manual_symbol?: string;
  manual_position_size?: number;
  // Position size multiplier
  position_size_multiplier: number;
}

export interface ParsedCsvRow {
  timestamp: string;
  pnl: number;
  signal: string;
  price: number;
  position_size: number;
  position_size_raw: string;
  position_value?: number;
  type?: string;
  runup_usd?: number;
  runup_percent?: number;
  drawdown_usd?: number;
  drawdown_percent?: number;
  cumulative_pnl?: number;
  cumulative_percent?: number;
  isSkipped?: boolean;
  skipReason?: string;
  filename?: string;
  symbol?: string; // Add symbol extraction
}

export interface FileParams extends AnalysisParams {
  fileId: string;
  filename: string;
}

export const getDefaultParams = (): AnalysisParams => ({
  tp_usd: 60,
  sl_usd: 120,
  quantity_base: 200,
  initial_capital: 10000,
  selected_qty_values: [],
  loss_streak_enabled: false,
  max_consecutive_losses: 3,
  resume_after_win: false,
  win_protect_enabled: false,
  win_protect_start_wins: 3,
  win_protect_max_wins: 5,
  win_protect_include_nth_win: false,
  win_protect_mode: 'consecutive_trades',
  // Default anti loss streak settings
  anti_loss_streak_enabled: false,
  wait_for_losses: 3,
  stop_after_losses: 2,
  reset_on_win: true,
  anti_loss_streak_mode: 'consecutive_losses',
  // Default percentage mode settings
  use_percentage_mode: false,
  tp_percent: 2.0,
  sl_percent: 2.0,
  auto_parse_filename: true,
  // Default position size multiplier
  position_size_multiplier: 1.0,
});